




























































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ICodeTable } from '@/models/Common';
import API from '@/Api';
import { triggerAsyncId } from 'async_hooks';
const namespace: string = 'AppStore';

@Component
export default class HRReports extends Vue {
  @Getter('role', { namespace }) public userRole: any;
  @Getter('name', { namespace }) public userName: any;
  public show: boolean = true;
  public file: string = '';
  public fileName: string = '';
  public dialog: boolean = false;
  public months: ICodeTable[] = [];
  public selectedMonth: any = {} as any;
  public save: boolean = false;
  public type: number = 0;
  public dateDialog: boolean = false;
  public startDate: string = '';
  public endDate: string = '';

  public mounted() {
    API.Instance.get('api/payroll-months/calendar').then((response) => {
      this.months = response.data;
      this.selectedMonth = this.months && this.months[0].id;
      document.domain = 'sulekha.com';
    });
  }
  public submitReport() {
    this.dateDialog = false;
    
    const apiUrl = `/api/reports?type=${this.type}&startDate=${this.startDate}&endDate=${this.endDate}`;
    API.Instance.get(apiUrl)
    .then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = this.type === 9 ? 'Joiners' : 'Leavers' +'.csv';
      link.click();
    })
  }

  public downloadLop() {
    this.dialog = false;
    const id = this.selectedMonth;
    API.Instance.get('/api/hr-reports?type=6&calendarId=' + id).then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'LOP.csv';
      link.click();
    });
  }

  public downloadManpower() {
    API.Instance.get('/api/reports?type=1').then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Manpower.csv';
      link.click();
    });
  }

  public downloadLeaveBalance() {
    API.Instance.get('/api/reports?type=2').then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'LeaveBalance.csv';
      link.click();
    });
  }

  public downloadPayrollReport() {
    this.dialog = false;
    const id = this.selectedMonth;
    API.Instance.get('/api/hr-reports?type=3&calendarId=' + id).then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'PayrollReport.csv';
      link.click();
    });
  }

  public downloadReportinandout() {
    this.dialog = false;
    const id = this.selectedMonth;
    
    API.Instance
    .get('/api/goalsettings/inandoutreport?calendarId='+ id)
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'In-OutTime.csv';
        link.click();
        this.dialog = false;
      });
  }

   public downloadReporttwodaysleave() {
    this.dialog = false;
    const id = this.selectedMonth;
    
    API.Instance
    .get('/api/goalsettings/twodaysleavereport?calendarId='+ id)
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Two-Days-Leave.csv';
        link.click();
        this.dialog = false;
      });
  }

  

  public downloadInOutTimeReport() {
    this.dialog = false;
    const id = this.selectedMonth;
    API.Instance.get('/api/hr-reports?type=4&calendarId=' + id).then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'In-OutTime.csv';
      link.click();
    });
  }

  public downloadInOutTimeReportnewtest() {
    this.dialog = false;
    const id = this.selectedMonth;
    API.Instance.get('/api/hr-reports?type=90&calendarId=' + id).then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'In-OutTime.csv';
      link.click();
    });
  }


  

  public downloadConanicalReport() {
    this.dialog = false;
    const id = this.selectedMonth;
    API.Instance.get('/api/reports?type=5&calendarId=' + id).then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Canonical.csv';
      link.click();
    });
  }
  public attendance() {
    this.dialog = false;
    const id = this.selectedMonth;
    API.Instance.get('/api/hr-reports?type=7&calendarId=' + id).then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Attendance.csv';
      link.click();
    });
  }
  public downloadPersonalDetailReport() {
    API.Instance.get('/api/reports?type=10').then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Personal-Details.csv';
      link.click();
    });
  }
  public downloadLeaversReport() {
    this.dialog = false;
    const id = this.selectedMonth;
    API.Instance.get('/api/reports?type=8&calendarId=' + id).then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'LeaversReport.csv';
      link.click();
    });
  }
  public downloadjoinersreport() {
    this.dialog = false;
    const id = this.selectedMonth;
    API.Instance.get('/api/reports?type=9&calendarId=' + id).then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'JoinersReport.csv';
      link.click();
    });
  }
  public downloadAmberReport() {
    API.Instance.get('/api/reports?type=12&calendarId=').then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'AmberReport.csv';
      link.click();
    });
  }
  public downloadBdeReport() {
    API.Instance.get('/api/reports?type=13&calendarId=').then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'BDEAttendance.csv';
      link.click();
    });
  }
  public downloadChangeHistory() {
    API.Instance.get('/api/reports?type=14&calendarId=').then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'ChangeHistory.csv';
      link.click();
    });
  }
  public downloadInspireEngagementReport() {
    API.Instance.get('/api/reports?type=22&calendarId=').then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'InspireEngagement.csv';
      link.click();
    });
  }

  public handleFileUpload(event: any) {
    this.file = event.target.files[0];
    this.fileName = event.target.files[0].name;
    const formData = new FormData();
    formData.append('file', this.file);
    API.Instance.post('api/week-off', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        this.$store.commit('AppStore/SNACK_BAR', {
          text: `${this.fileName} has been uploaded successfully!`,
          show: true,
        });
      })
      .catch(() => {
        this.$store.commit('AppStore/SNACK_BAR', {
          text: `Can't upload the given file, Please check the content!`,
          show: true,
        });
      })
      .then(() => {
        window.location.reload();
      });
  }
  get uploadkeyhire() {
    return '/key-hire/v1';
  }

  public close() {
    this.dialog = false;
  }
  public submit() {
    if (this.type === 1) {
      this.downloadLop();
    }
    if (this.type === 2) {
      this.downloadManpower();
    }
    if (this.type === 3) {
      this.downloadLeaveBalance();
    }
    if (this.type === 4) {
      this.downloadPayrollReport();
      
    }
    if (this.type === 5) {
      //this.downloadInOutTimeReport();
      this.downloadReportinandout();
    }
    if (this.type === 100) {
      //this.downloadInOutTimeReport();
      this.downloadReporttwodaysleave();
    }
    if (this.type === 6) {
      this.downloadConanicalReport();
    }
    if (this.type === 7) {
      this.attendance();
    }
    if (this.type === 8) {
      this.downloadPersonalDetailReport();
    }
    if (this.type === 9) {
      this.downloadLeaversReport();
    }
    if (this.type === 10) {
      this.downloadjoinersreport();
    }
    if (this.type === 21) {
      this.downloadLeaveReportV2(this.selectedMonth);
    }

    if (this.type === 90) {
      this.downloadInOutTimeReportnewtest();
    }

  }
  get getDetail() {
    return '/add-division';
  }

  public getSclReport() {
    API.Instance.get('/api/reports?type=11&calendarId=0').then((response) => {
      const blob = new Blob([response.data], { type: 'application/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'SclReport.csv';
      link.click();
    });
  }
  public downloadInAndOutCutoff() {
    API.Instance
    .get('/api/reports?type=15&calendarId=').then((response) => {
      const blob = new Blob([response.data], {type: 'application/csv'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'CutoffReport.csv';
      link.click();
    });
  }
  public downloadLeaveReport() {
    API.Instance
    .get('/api/reports?type=16&calendarId=').then((response) => {
      const blob = new Blob([response.data], {type: 'application/csv'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'LeaveReport.csv';
      link.click();
    });
  }
  public downloadLeaveReportV2(calendarId: any) {
    API.Instance
    .get(`/api/reports?type=21&calendarId=${calendarId}`).then((response) => {
      const blob = new Blob([response.data], {type: 'application/csv'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'LeaveReport.csv';
      link.click();
    });
  }
  public downloadExitInterviewReport() {
    API.Instance
    .get('/api/reports?type=17&calendarId=').then((response) => {
      const blob = new Blob([response.data], {type: 'application/csv'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'ExitInterviewReport.csv';
      link.click();
    });
  }
  public downloadBirthdayReport() {
    API.Instance
    .get('/api/reports?type=18&calendarId=').then((response) => {
      const blob = new Blob([response.data], {type: 'application/csv'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'BirthdayReport.csv';
      link.click();
    });
  }
  public downloadWorkAnniversaryReport() {
    API.Instance
    .get('/api/reports?type=19&calendarId=').then((response) => {
      const blob = new Blob([response.data], {type: 'application/csv'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'WorkAnniversaryReport.csv';
      link.click();
    });
  }
  public downloadInsuranceDetailsReport() {
    API.Instance
    .get('/api/reports?type=20&calendarId=').then((response) => {
      const blob = new Blob([response.data], {type: 'application/csv'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'InsuranceDetails.csv';
      link.click();
    });
  }
  public downloadMaternityLeaveReport() {
    API.Instance
    .get('/api/maternity-leave?type=16&calendarId=').then((response) => {
      const blob = new Blob([response.data], {type: 'application/csv'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'MaternityLeaveReport.csv';
      link.click();
    });
  }
  get getTriggerMail() {
    return '/trigger-mail';
  }
  get getOnboarding() {
    return '/onboarding';
  }
  get getempconversation() {
    return '/employee-conversation';
  }
  
  get getShift() {
    return '/shift-check';
  }
  get resignationAcceptanceLink() {
    return '/resignation-acceptance';
  }
}
